module.exports = __webpack_public_path__ + "Server-Unhealthy-AzureCloudService.f2b0582dbf78fc7c17ae4886ecbda47f.hashedasset.svg";